export function maskEmail(email?: string): string {
  if (!email) {
    return '';
  }

  const [user, domain] = email.split('@');
  if (!user || !domain) {
    return email;
  }

  const maskedUser =
    user.length <= 2
      ? user[0] + '*'
      : user[0] + '*'.repeat(user.length - 2) + user[user.length - 1];

  return `${maskedUser}@${domain}`;
}
